var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSentSuccessfully = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 160 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m86.762 75.686.272 19.904c20.581-14.347 41.157-28.694 61.738-43.04-20.672 7.712-41.344 15.424-62.01 23.136Z",
  fill: "#062E2A",
  stroke: "#062E2A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M104.281 99.483c-5.84-7.93-11.68-15.867-17.525-23.797l.272 19.904c-1.632-6.912-3.259-13.819-4.89-20.73-6.06-1.878-12.113-3.75-18.171-5.627 28.267-5.563 56.533-11.12 84.8-16.683-14.827 15.648-29.654 31.29-44.486 46.933Z",
  fill: "#FFDB16",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.137 74.864c22.208-7.435 44.421-14.875 66.629-22.31l-66.63 22.31Z",
  fill: "#F6E6F2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M82.137 74.864c22.208-7.435 44.421-14.875 66.629-22.31",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m86.762 75.686 62.01-23.136-62.01 23.136Z",
  fill: "#F6E6F2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m86.762 75.686 62.01-23.136",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.356 140.608c.854-12.048-2.133-19.477-5.088-24.075-1.109-1.728-4.591-5.744-11.503-13.808-5.307-6.186-9.04-10.346-7.787-13.685.064-.165.875-2.23 2.795-2.725 2.213-.571 4.192 1.397 4.362 1.573-2.485-2.763-1.893-6.875.582-8.581 2.032-1.403 5.178-1.083 7.232 1.045-2.555-3.019-1.649-7.173.703-8.528 1.931-1.11 5.03-.459 6.902 1.973-1.766-2.698-2.016-5.456-.763-6.87.736-.831 1.803-.98 2.08-1.018 2.89-.378 5.568 2.55 7.563 4.934 7.67 9.146 12.027 18.234 12.837 19.946a150.838 150.838 0 0 1 3.782 8.699c-.32-6.63 1.397-11.45 4.197-12.224.101-.027 1.488-.39 2.688.395 2.165 1.413 2.09 5.488.096 17.061-1.456 8.443-2.139 12.683-3.099 15.723-1.995 6.336-5.84 16-13.579 26.677-.384.347-3.349 2.944-7.136 2.235-3.717-.704-6.682-4.294-6.864-8.747Z",
  fill: "#D3EAC2",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.555 73.797a66.946 66.946 0 0 1 6.832 8.091 67.104 67.104 0 0 1 7.696 14.027",
  fill: "#D3EAC2"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M34.555 73.797a66.946 66.946 0 0 1 6.832 8.091 67.104 67.104 0 0 1 7.696 14.027",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M26.95 80.352a53.025 53.025 0 0 1 8.453 8.89 53.068 53.068 0 0 1 6.33 10.945",
  fill: "#D3EAC2"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M26.95 80.352a53.025 53.025 0 0 1 8.453 8.89 53.068 53.068 0 0 1 6.33 10.945",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.135 87.888a48.521 48.521 0 0 1 8.57 7.344 48.548 48.548 0 0 1 7.696 11.12",
  fill: "#D3EAC2"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M19.135 87.888a48.521 48.521 0 0 1 8.57 7.344 48.548 48.548 0 0 1 7.696 11.12M106.164 10.848c-.858.085-1.994.25-3.29.592C91.178 14.5 78.751 28.485 82.41 40.122c2.464 7.835 12.229 14.848 19.845 12.448 3.621-1.141 7.029-4.496 7.712-8.533 1.067-6.304-4.832-12.32-9.808-14.752-14.021-6.864-32.304 9.013-33.173 9.787-10.523 9.365-13.584 21.45-14.582 26.949",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M108.816 10.694a17.374 17.374 0 0 1 3.6.176 16.63 16.63 0 0 1 2.342.533",
  fill: "#E9F3E6"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M108.816 10.694a17.374 17.374 0 0 1 3.6.176 16.63 16.63 0 0 1 2.342.533M65.023 134.368c9.42-1.008 14.038-4.442 16.512-7.296 5.334-6.16 3.872-13.344 10.102-18.325 3.578-2.864 7.813-3.488 10.581-3.616",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M124.681 36c-1.898-3.99-3.194-5.888-3.888-5.686-.97.278-.762 4.646.619 13.105 7.115-6.096 10.437-9.472 9.968-10.123-.336-.47-2.565.437-6.699 2.704Z",
  fill: "#7BDB83",
  stroke: "#1A1A1A",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSentSuccessfully;